<template>
  <div class="ps-text-select">
    <div v-if="placeholder" class="pb-2">{{ $t(label) }}</div>
    <component
      :is="searchable ? 'v-autocomplete' : 'v-select'"
      color="primary"
      :flat="flat"
      :outlined="outlined"
      :dense="dense"
      :rounded="rounded"
      :disabled="disabled"
      :hide-details="hideDetails"
      :items="items"
      v-model="model"
      :item-text="text"
      :item-value="itemValue"
      :error-messages="errorMessages"
      :return-object="returnObject"
      :multiple="multiple"
      :chips="chips"
      :small-chips="smallChips"
      :deletable-chips="deletableChips"
      :no-data-text="$t('no_data')"
      :filled="filled"
      :placeholder="placeholderText"
      :clearable="clearable"
      :menu-props="menuProps"
      :auto-select-first="searchable && autoSelectFirst ? true : undefined"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    placeholder: { type: Boolean, default: true },
    returnObject: { type: Boolean, default: true },
    label: { type: String, require: true },
    items: { type: Array, require: true },
    errorMessages: { type: Array, require: true },
    flat: { type: Boolean, default: false },
    outlined: { type: Boolean, default: true },
    dense: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    counter: { type: Boolean, default: false },
    filled: { type: Boolean, default: false },
    rounded: { type: Boolean, default: false },
    text: { type: String, default: "text" },
    itemValue: { type: String, default: "text" },
    multiple: { type: Boolean, default: false },
    chips: { type: Boolean, default: false },
    smallChips: { type: Boolean, default: false },
    deletableChips: { type: Boolean, default: false },
    searchable: { type: Boolean, default: true },
    clearable: { type: Boolean, default: false },
    autoSelectFirst: { type: Boolean, default: false },
  },

  data() {
    return {
      model: this.value,
    };
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) this.model = newVal;
    },
    model(newVal, oldVal) {
      if (newVal !== oldVal) this.$emit("input", newVal);
    },
  },
  computed: {
    hideDetails() {
      // if (this.errorMessages && this.errorMessages.length) {
      //   return false;
      // }
      return true;
    },
    placeholderText() {
      if (typeof this.placeholder === "string") {
        return this.placeholder;
      }
      return this.placeholder ? this.$t(this.label) : "";
    },
    menuProps() {
      // Keep menu usable on mobile and long lists
      return {
        maxHeight: "320px",
        offsetY: true,
      };
    },
  },
};
</script>

<style></style>
